import { render, staticRenderFns } from "./TopTitle.vue?vue&type=template&id=2640ecb4&scoped=true&"
import script from "./TopTitle.vue?vue&type=script&lang=js&"
export * from "./TopTitle.vue?vue&type=script&lang=js&"
import style0 from "./TopTitle.vue?vue&type=style&index=0&id=2640ecb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640ecb4",
  null
  
)

export default component.exports